<template>
    <form @submit.prevent="handleSubmit($event)">
        <div class="form-row mt-1">
            <div class="form-group">
                <input
                    v-model="form.name"
                    name="name"
                    type="text"
                    :class="['custom-input-transparent', {'is-invalid': formErrors.includes('name')}]"
                    placeholder="Nombre (s)"
                    @focus="trackFormFieldFocus('register_input-name')"
                >
            </div>
            <div class="form-group">
                <input
                    v-model="form.last_name"
                    name="last_name"
                    type="text"
                    :class="['custom-input-transparent', {'is-invalid': formErrors.includes('last_name')}]"
                    placeholder="Apellidos"
                    @focus="trackFormFieldFocus('register_input-last_name')"
                >
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group">
                <input
                    v-model="form.email"
                    name="email"
                    type="text"
                    :class="['custom-input-transparent', {'is-invalid': formErrors.includes('email')}]"
                    placeholder="Email"
                    @focus="trackFormFieldFocus('register_input-email')"
                >
            </div>
            <div class="form-group">
                <!-- <input v-model="form.phone_number" name="phone_number" type="number" :class="['custom-input-transparent', {'is-invalid': formErrors.includes('phone_number')}]" placeholder="Telefono"> -->
                 <PhoneInput
                    v-model:phone="form.phone_number"
                    v-model:dialCode="form.dial_code"
                    @focus="trackFormFieldFocus('register_input-phone_number')"
                ></PhoneInput>
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group w-100">
                <InputPasswordGen
                    v-model="form.password"
                    v-model:visible="passwordVisible"
                    :valid="formErrors.includes('password')"
                    @newPassword="onGeneratePassword"
                    @focus="trackFormFieldFocus('register_input-password')"
                >
                </InputPasswordGen>
                <PasswordStrength v-model="passwordStrength" :password="form.password" />
            </div>
            <div class="form-group">
                <input
                    v-model="form.password_confirmation"
                    name="password_confirmation"
                    :type="passwordVisible ? 'text' : 'password'"
                    :class="['custom-input-transparent', {'is-invalid': formErrors.includes('password_confirmation')}]"
                    placeholder="Confirmar contraseña"
                    @focus="trackFormFieldFocus('register_input-password_confirmation')"
                >
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group">
                <input
                    v-model="formattedInputRFC"
                    name="rfc"
                    :class="['custom-input-transparent', {'is-invalid': formErrors.includes('rfc')}]"
                    placeholder="RFC*"
                    @focus="trackFormFieldFocus('register_input-rfc')"
                >
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group">
                <input
                    v-model="form.address.line_1"
                    name="address[line_1]"
                    type="text"
                    :class="['custom-input-transparent', {'is-invalid': formErrors.includes('line_1')}]"
                    placeholder="Dirección *"
                    @focus="trackFormFieldFocus('register_input-address[line_1]')"
                >
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group">
                <input
                    v-model="form.address.line_2"
                    name="address[line_2]"
                    type="text"
                    :class="['custom-input-transparent', {'is-invalid': formErrors.includes('line_2')}]"
                    placeholder="Colonia *"
                    @focus="trackFormFieldFocus('register_input-address[line_2]')"
                >
            </div>
            <div class="form-group">
                <input
                    v-model="form.address.postal_code"
                    maxlength="5"
                    name="address[postal_code]"
                    type="text"
                    :class="['custom-input-transparent', {'is-invalid': formErrors.includes('postal_code')}]"
                    placeholder="Código postal *"
                    pattern="\d*"
                    oninput="this.value = this.value.replace(/\D/g, '')"
                    @focus="trackFormFieldFocus('register_input-address[postal_code]')"
                >
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group">
                <input
                    v-model="form.address.state"
                    name="address[state]"
                    type="text"
                    :class="['custom-input-transparent', {'is-invalid': formErrors.includes('state')}]"
                    placeholder="Estado *"
                    @focus="trackFormFieldFocus('register_input-address[state]')"
                >
            </div>

            <div class="form-group">
                <CountryReadOnly></CountryReadOnly>
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group">
                <input
                    v-model="form.address.city"
                    name="address[city]"
                    type="text"
                    :class="['custom-input-transparent', {'is-invalid': formErrors.includes('city')}]"
                    placeholder="Ciudad *"
                    @focus="trackFormFieldFocus('register_input-address[city]')"
                >
            </div>
            <div class="form-group">
                <input
                    name="address[line_3]"
                    type="text"
                    class="custom-input-transparent"
                    placeholder="Referencia de domicilio (opcional)"
                    v-model="form.address.line_3"
                    @focus="trackFormFieldFocus('register_input-address[line_3]')"
                >
            </div>
        </div>
        <div class="form-row mt-1 d-none">
            <ProductsToImport
                v-model:products="form.products_import"
                :listErrors="formErrors"
                :companyName="companyName"
            ></ProductsToImport>
        </div>
        
        <ul class="font-sm danger-color my-1 ml-1" v-if="error">
            <li v-for="error in error.errors"> {{error}}</li>
        </ul>
        <div class="w-100 my-1">
            <input
                v-model="form.chboxAgree"
                id="chbox-agree"
                name="chboxAgree"
                type="checkbox"
                class="custom-checkbox"
                value="on"
                    @focus="trackFormFieldFocus('register_input-chbox_agree')"
            >
            <label for="chbox-agree" class="font-semibold font-sm ml-1">Estoy de acuerdo con el documento de </label><label @click.prevent="showFordibbenItems()" class="font-semibold font-sm cursor-pointer text-underline">articulos prohibidos</label>
        </div>

        <TransitionLabel
            labelClass="error-label w-100 mt-1"
            :show="validation.show"
        >
            {{validation.message}}
        </TransitionLabel>

        <div class="w-100 text-right">
            <button class="btn-primary">Registrarme</button>
        </div>
    </form>
    <ModalComponent
        v-model="modalImageFordibbenItems"
        width="80vh"
    >
        <img
            v-if="srsFordibbenItems && srsFordibbenItems!== ''"
            :src="srsFordibbenItems"
            style="width: 100%;"
        >
    </ModalComponent>
</template>
<script>
import { useGoogleAnalytics } from '../../composables/useGoogleAnalytics';
import { useSwalFire } from '../../composables/useSwalFire';
import CountryReadOnly from '../../global-components/CountryReadOnly.vue';
import InputPasswordGen from '../../global-components/InputPasswordGen.vue';
import ModalComponent from '../../global-components/ModalComponent.vue';
import PasswordStrength from '../../global-components/PasswordStrength.vue';
import PhoneInput from '../../global-components/PhoneInput.vue';
import TransitionLabel from '../../global-components/TransitionLabel.vue';
import apiClient from '../../services/apiClient';
import ProductsToImport from './forms/ProductsToImport.vue';

export default {
    components: {
        TransitionLabel,
        PasswordStrength,
        ModalComponent,
        PhoneInput,
        ProductsToImport,
        InputPasswordGen,
        CountryReadOnly
    },
    name: 'signup-form',
    props: {
        srsFordibbenItems: {
            type: String,
            default: ''
        },
        companyName: String
    },
    setup() {
        const {trackPageView, trackFormFieldFocus, trackFormSubmission} = useGoogleAnalytics()
        return {trackPageView, trackFormFieldFocus, trackFormSubmission}
    },
    data() {
        return {
            error: '',
            validation: {
                show: false,
                message: ''
            },
            passwordVisible: false,
            modalImageFordibbenItems: false,
            formErrors: [],
            passwordStrength: 0,
            form: {
                name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                phone_number: null,
                rfc: '',
                address: {
                    line_1: '',
                    line_2: '',
                    postal_code: '',
                    state: '',
                    city: '',
                    line_3: ''
                },
                products_import: ['', ''],
                chboxAgree: true,
                dial_code: '+52'
            },
        }
    },
    methods: {
        handleSubmit() {
            this.error = '';
            this.formErrors = [];
            this.validation.show= false
            this.validation.message= ''

            if (this.form.password !== this.form.password_confirmation) this.setAlert('⚠️ La contraseña no coincide')

            if(this.passwordStrength <= 2) {
                this.formErrors.push('password');
                this.setAlert('Tu contraseña no es muy segura. Intenta usar una combinación de mayúsculas, minúsculas, números y caracteres especiales para mayor seguridad. 🔒')
            }

            for(let field in this.form) 
                if(!this.form[field]) this.formErrors.push(field);

            for(let field in this.form.address) {
                if (field === 'line_3') continue; // line_3 is optional
                if(!this.form.address[field]) this.formErrors.push(field);
            }

            const phoneRegex = /^\d{10}$/;
            if (!phoneRegex.test(this.form.phone_number)) this.setAlert('⚠️ Ingresa un número de teléfono válido de 10 dígitos.')

            if (this.form.products_import.length === 0) this.setAlert('⚠️ Debes agregar al menos un producto a importar.')
            if (!this.form.products_import.every(product => product && product.trim() !== '')) this.setAlert('⚠️ No se puede dejar ningun campo de productos vacio.')
            this.form.products_import.forEach((val, index) => {
                if (!val || val.trim() === '') this.formErrors.push(`product-${index}`)
            })

            if(this.formErrors.length > 0 || this.validation.show) return;
            this.signup(this.form);
        },
        async signup(formData) {
            this.trackFormSubmission('on_submit_register_form')
            try {
                const response = await apiClient.post('/api/auth/create', formData)
                if(response.data && response.data.access_token !== undefined)
                    this.notifySuccess()
                else
                    this.error = response;
            } catch (error) {
                this.setError(error)
            }
        },
        setAlert (message) {
            this.validation.message = message
            this.validation.show = true
        },
        setError (error) {
            const data = error.response.data
            if (data.message)
                this.validation.message = `⚠️ ${error.response.data.message}`

            if (data && data.errors && data.errors.email) {
                this.validation.message = `⚠️ ${data.errors.email[0]}`
                this.formErrors.push('email')
            }

            this.validation.show = true
        },
        notifySuccess () {
            const swalNotify = useSwalFire()
            swalNotify.onSuccessNotify({title: '¡Usuario Creado!', label: 'Tu registro se completo correctamente.'})
            .then(() => {
                let redirect_to = sessionStorage.getItem('redirect_to') ?? '/';
                sessionStorage.removeItem('redirect_to');
                location.href = redirect_to;
            });
        },
        showFordibbenItems () {
            this.modalImageFordibbenItems = true
        },
        onGeneratePassword (password) {
            this.form.password = password;
            this.form.password_confirmation = password;
        }
    },
    mounted () {
        this.trackPageView('SIGNUP_FORM')
    },
    computed: {
        formattedInputRFC: {
            get() {
                return this.form.rfc;
            },
            set(value) {
                this.form.rfc = value.toUpperCase().replace(/\s/g, '');
            }
        }
    },
}
</script>